export default (theSpecial, cartItem) => {

    let itemPrice = parseFloat(theSpecial.price);

    // calculate any extra costs on the items
    cartItem.items.forEach((theItem, theItemIndex) => {

        let currentItemChoice = {};
        if (theSpecial.items) {
            theSpecial.items.forEach((theChoices) => {
                theChoices.choices.forEach((theChoice) => {
                    if (theChoice.id == theItem.choice_id) {
                        currentItemChoice = theChoice;
                    }
                });
            });
        }


        if (theItem.type == "custompizza") {

        	// crusts
        	if (theItem.crust_id && currentItemChoice.crusts) {
                currentItemChoice.crusts.forEach((theCrust) => {
                    if (theCrust.id == theItem.crust_id) {
                        itemPrice += parseFloat(theCrust.price);
                    }
                });
        	}

        	// sauces
        	if (theItem.sauce_id && currentItemChoice.sauces) {
                currentItemChoice.sauces.forEach((theSauce) => {
                    if (theSauce.id == theItem.sauce_id) {
                        itemPrice += parseFloat(theSauce.price);
                    }
                });
        	}
        }
        else if (theItem.type == "pizza") {

            // add any applicable costs from the toppings    
            theItem.toppings.forEach((theCartTopping) => {

                if (theCartTopping.isdefault == true && theCartTopping.amount == "extra") {
                    currentItemChoice.toppings.forEach((theTopping) => {
                        if (theTopping.id == theCartTopping.id) {
                            itemPrice += parseFloat(theTopping.price);
                        }
                    });
                }
                else if (!theCartTopping.isdefault && theCartTopping.amount == "include") {

                    currentItemChoice.toppings.forEach((theTopping) => {
                        if (theTopping.id == theCartTopping.id) {
                            itemPrice += parseFloat(theTopping.price);
                        }
                    });
                }
            });

            if (theItem.crust_id && currentItemChoice.crusts) {

                currentItemChoice.crusts.forEach((theCrust) => {
                    if (theCrust.id == theItem.crust_id) {
                        itemPrice += parseFloat(theCrust.price);
                    }
                });
            }

            // sauces
            if (theItem.sauce_id && currentItemChoice.sauces) {

                currentItemChoice.sauces.forEach((theSauce) => {
                    if (theSauce.id == theItem.sauce_id) {
                        itemPrice += parseFloat(theSauce.price);
                    }
                });
            }
        }
        else if (theItem.type == "fooditem") {

            // add any applicable choice prices
            theItem.choices.forEach((theSelectedChoice) => {

                if (!theSelectedChoice.is_multiple) {
                    itemPrice += parseFloat(theSelectedChoice.item_price);
                }
                else {
                    let currentChoicePrice = 0.00;

                    theSelectedChoice.items.forEach((theSelectedChoiceItem) => {

                        theSpecial.items.forEach((theSpecialItem) => {
                            theSpecialItem.choices.forEach((theSpecialItemChoice) => {
                                if (theSpecialItemChoice.id == theItem.id) {


                                    theSpecialItemChoice.fooditem.choices.forEach((theSpecialFoodItemChoice) => {
                                        theSpecialFoodItemChoice.selections.forEach((theSpecialFoodItemChoiceItem) => {
                                            if (theSpecialFoodItemChoiceItem.id == theSelectedChoiceItem) {
                                                currentChoicePrice += parseFloat(theSpecialFoodItemChoiceItem.price);
                                            }
                                        });
                                    });
                                }
                            });
                        });
                    });

                    itemPrice += parseFloat(currentChoicePrice);
                }
            });

            // add the prices for each addon
            theItem.addons.forEach((theSelectedAddon, theAddonIndex) => {
                currentItemChoice.fooditem.addons.forEach((theAddon) => {
                    if (theAddon.id == theSelectedAddon) {
                        itemPrice += parseFloat(theAddon.price);
                    }
                })
            });
        }
    });

    itemPrice *= cartItem.quantity;
    
    return itemPrice;
}